module.exports = __webpack_public_path__ + "img/transport-pathway.0be7cb1a.jpg";